var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C4.40326 1.09674 4.06802 1.90609 4.06802 2.75C4.06802 3.59391 4.40326 4.40326 5 5C5.59674 5.59674 6.40609 5.93198 7.25 5.93198C8.09392 5.93198 8.90326 5.59674 9.5 5C9.5 5.89002 9.23608 6.76004 8.74162 7.50007C8.24715 8.24009 7.54434 8.81686 6.72208 9.15746C5.89981 9.49805 4.99501 9.58717 4.1221 9.41353C3.24918 9.2399 2.44736 8.81132 1.81802 8.18198C1.18869 7.55264 0.760102 6.75082 0.586468 5.87791C0.412835 5.00499 0.50195 4.10019 0.842544 3.27792C1.18314 2.45566 1.75991 1.75285 2.49994 1.25839C3.23996 0.76392 4.10999 0.5 5 0.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.023c4fa329856073bbabd6df1229785b.svg";
export { ForwardRef as ReactComponent };